import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { analytics, EVENTS } from "../analytics";

const HomeFinalCtaSection: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const currentMonth = `${new Date().getMonth() + 1}월`;

  const s = t("finalCtaSection", { returnObjects: true }) as {
    title: string;
    subtitle: string;
    cta1: { text: string; path: string };
    cta2: { text: string; path: string };
  };

  return (
    <section className="py-24 bg-main text-white">
      <div className="max-w-2xl mx-auto px-4 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-3xl md:text-4xl font-extrabold mb-4"
        >
          {s.title}
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1 }}
          className="text-white/60 mb-10"
        >
          {s.subtitle}
        </motion.p>

        <p className="text-gold text-[10px] font-bold tracking-[3px] uppercase mb-4">마감 임박</p>
        <h2 className="text-2xl sm:text-3xl font-extrabold text-white leading-tight mb-4">
          {currentMonth} 문의 마감 전에
          <br />
          지금 신청하세요.
        </h2>
        <p className="text-white/60 text-sm leading-relaxed max-w-xs mx-auto mb-2">
          매달 받을 수 있는 신청 수가 정해져 있습니다.
          <br />
          준비가 됐다면 지금이 가장 빠른 시작입니다.
        </p>
        <p className="text-white/30 text-xs mb-10">자리가 마감되면 다음 달로 이월됩니다.</p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className="flex flex-col sm:flex-row gap-4 justify-center"
        >
          <button
            onClick={() => {
              navigate(s.cta1.path);
              window.scrollTo({ top: 0, behavior: "smooth" });
              analytics.track(EVENTS.CLICK_HOME_FINAL_TO_DIAGNOSE);
            }}
            className="bg-accent text-main font-bold px-8 py-4 rounded-xl hover:bg-yellow-500 transition-colors"
          >
            {s.cta1.text}
          </button>
          <button
            onClick={() => {
              navigate(s.cta2.path);
              window.scrollTo({ top: 0, behavior: "smooth" });
              analytics.track(EVENTS.CLICK_HOME_FINAL_TO_SERVICE);
            }}
            className="border border-white/30 text-white font-bold px-8 py-4 rounded-xl hover:bg-white/10 transition-colors"
          >
            {s.cta2.text}
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default HomeFinalCtaSection;
